import React from 'react';
import puppies from '../images/common/puppies.JPG';

import { column, contactWord, halfImage } from '../../app/styles';


class Contact extends React.Component {
    
    row = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        width: '77%',
        marginBottom: '60px'
    }

    render() {
        return (
            <div style={column}>
                <div style={contactWord}>
                    <h1>Ben Sander</h1>
                    <h2>Cheney, WA</h2>
                    <h2>bsander118@outlook.com</h2>
                </div>
                <div style={this.row}>
                    <img style={halfImage} src={puppies} alt='Leo and Bucky' />
                </div>
            </div>
        );
    }
}

export default Contact;